// @ts-strict-ignore
/** @jsx jsx */
import { useForm } from 'react-hook-form'
import { jsx } from 'theme-ui'
import { isEmpty } from '@uswitch/ev-utils/obj'
import React, { useEffect, useRef } from 'react'
import CalculatorField from './calculator-field'
import { Button } from '@uswitch/ev-components/lib/components/elements/trustyle-button'

interface CalculatorFormProps {
  schema: {
    steps: [any]
    action: any
    method: any
    formId: string
    defaultInputs: object
    variant: string
    disableButtonUntilValid: boolean
  }
  trackInteraction: (m?: string, message?: string, error?: string) => void
  submit: (data: any) => void
}

const CalculatorForm: React.FC<CalculatorFormProps> = ({
  schema: {
    steps = [],
    action,
    method,
    formId,
    defaultInputs,
    variant = 'default',
    disableButtonUntilValid = false,
  },
  trackInteraction = () => {},
  submit,
}) => {
  const { register, handleSubmit, errors, setValue, formState, watch, getValues } = useForm({
    mode: 'all',
    defaultValues: {
      ...defaultInputs,
    },
  })

  const isVisible = (field: any) => {
    if (!field.visibleIf) return true

    return (
      (field.visibleIf.or || []).some((e) => watch(e.field) === e.equals) &&
      (field.visibleIf.and || []).every((e) => watch(e.field) === e.equals)
    )
  }
  const getVisibleFields = (fields = []) => fields.filter((field) => isVisible(field))
  const fields = getVisibleFields(steps[0].fields)

  const { buttonProps, id } = steps[0]!

  const form = useRef(null)
  const { isValid } = formState

  useEffect(() => {
    // This logic is to swap the currencies on travel money calc
    const urlSearchParams = new URLSearchParams(window.location.search)
    const swap = urlSearchParams.get('swapped')
    if (swap === 'true') {
      setTimeout(() => {
        document.querySelector('#swap')?.click()
      }, 1)
      setTimeout(() => {
        document.querySelector('#calculator-submit')?.click()
      }, 10)
    }
  }, [])

  return (
    <form
      name={`calculator-form`}
      action={action}
      method={method}
      onSubmit={handleSubmit(submit)}
      ref={form}
      sx={{ variant: `elements.form.variants.field-section.formWrapper` }}
      id={formId}
    >
      <div
        id={id}
        sx={{
          variant: 'elements.form.variants.field-section.wrapper',
        }}
      >
        <div
          sx={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
          }}
        >
          {fields.map((field, i) => {
            return (
              <CalculatorField
                field={field}
                key={`field-${i}`}
                register={register}
                errors={errors}
                setValue={setValue}
                variant={'field-section'}
                getValues={getValues}
                trackInteraction={trackInteraction}
              />
            )
          })}
        </div>
        {buttonProps && (
          <div
            sx={{
              textAlign: 'center',
              '@media screen and (max-width: 425px)': {
                marginTop: '8px',
              },
            }}
          >
            <Button
              id={'calculator-submit'}
              type='submit'
              disabled={
                (disableButtonUntilValid && !isValid) ||
                !isEmpty(Object.keys(errors).filter((e) => fields.map((f) => f.name).includes(e)))
              }
              onClick={() => {}}
              sx={{
                display: 'inline-flex',
                variant: 'elements.buttons.variants.primary',
              }}
              variant={variant}
              key={`${buttonProps.label}-${buttonProps.index}`}
              size={buttonProps.size || 'large'}
            >
              {buttonProps.label}
            </Button>
          </div>
        )}
      </div>
    </form>
  )
}

export default CalculatorForm
